import { AircraftSearchResultDetailView } from '@/features/AssetDetailView/AircraftSearch/AircraftSearchResultDetailView';
import { validateAircraftSearchSearch } from '@/features/AssetDetailView/AircraftSearch/searchParams';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/asset_collection/assets/$assetId/projects/$projectId/search/$docId',
)({
    component: AircraftSearchResultDetailView,
    validateSearch: validateAircraftSearchSearch,
});
